import { render, staticRenderFns } from "./CreatePosts.vue?vue&type=template&id=6ec09bca&scoped=true"
import script from "./CreatePosts.vue?vue&type=script&lang=js"
export * from "./CreatePosts.vue?vue&type=script&lang=js"
import style0 from "./CreatePosts.vue?vue&type=style&index=0&id=6ec09bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec09bca",
  null
  
)

export default component.exports